import type { ContractChangeData, ProjectData } from 'gql/graphql';
import { cnTabsTab, cnText, cnListItem, cnListItemGrid } from 'uikit';

import cn from 'classnames';
import { useCallback, useMemo, useState } from 'react';

import Styles from './AgreementForm.module.css';

export enum CounterIdEnum {
    UerRowCount = 'uerRowCount',
    MtrRowCount = 'mtrRowCount',
    RatioRowCount = 'ratioRowCount',
    OtherRowCount = 'otherRowCount',
}
interface ITabItem {
    id: number;
    label: string;
    counterId: CounterIdEnum;
}

export const useAgreementForm = ({
    agreementItemData,
    projectData,
}: {
    agreementItemData: ContractChangeData | undefined | null;
    projectData: ProjectData | undefined | null;
}) => {
    const layoutTitleNumber = useMemo(
        () => (agreementItemData?.internalNumber ? `№${agreementItemData?.internalNumber}` : ''),
        [agreementItemData?.internalNumber],
    );
    const breadCrumbsItems = useMemo(() => {
        const { uniqueId, name, methodology } = projectData ?? {};
        const lowerMethodology = methodology?.toLowerCase();

        return [
            {
                label: name,
                href: `/projects/${lowerMethodology}/${uniqueId}`,
            },
            {
                label: 'Договор',
                href: `/projects/${lowerMethodology}/${uniqueId}/contract`,
            },
            {
                label: 'Реестр доп. соглашений',
                href: '..',
            },
        ];
    }, [projectData]);

    const tabItems: ITabItem[] = useMemo(
        () => [
            { id: 1, label: `Расценки`, counterId: CounterIdEnum.UerRowCount },
            { id: 2, label: `МТР`, counterId: CounterIdEnum.MtrRowCount },
            { id: 3, label: `Коэффициенты`, counterId: CounterIdEnum.RatioRowCount },
            { id: 4, label: `Прочие`, counterId: CounterIdEnum.OtherRowCount },
        ],
        [],
    );
    const [currentTab, setCurrentTab] = useState(tabItems[0]);

    const tabCounter = useMemo(
        () => ({
            uerRowCount: agreementItemData?.uerRowCount,
            mtrRowCount: agreementItemData?.mtrRowCount,
            ratioRowCount: agreementItemData?.ratioRowCount,
            otherRowCount: agreementItemData?.otherRowCount,
        }),
        [
            agreementItemData?.mtrRowCount,
            agreementItemData?.otherRowCount,
            agreementItemData?.ratioRowCount,
            agreementItemData?.uerRowCount,
        ],
    ) as Record<string, number>;

    const getTabLabel = useCallback((item) => item.label, []);
    const onChangeTab = useCallback(({ value }) => setCurrentTab(value), []);
    const renderTabItem = useCallback(
        ({ item, onChange, checked }) => (
            <button
                type="button"
                role="tab"
                onClick={onChange}
                style={{ marginBottom: '6px', padding: 0, cursor: 'pointer' }}
                className={cn(
                    cnText({ lineHeight: 'xs', size: 's', type: 'button', view: 'primary' }),
                    cnListItem(),
                    cnListItemGrid(),
                    cnTabsTab({ checked }),
                    'MixFocus MixFocus_before',
                )}
            >
                {item.label}
                <span className={Styles.counter}>{tabCounter[item.counterId]}</span>
            </button>
        ),
        [tabCounter],
    );

    return {
        layoutTitleNumber,
        breadCrumbsItems,
        getTabLabel,
        onChangeTab,
        renderTabItem,
        currentTab,
        tabItems,
    };
};
